"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
var React = require("react");
var member_info_1 = require("./member-info");
var member_participation_overview_1 = require("./member-participation-overview");
var member_history_1 = require("./member-history");
var frontend_toolkit_1 = require("frontend-toolkit");
var constants_1 = require("../../core/constants");
var react_apollo_1 = require("react-apollo");
var ShowMember = require("../../core/gql/queries/show-member");
var ShowMemberHistory = require("../../core/gql/queries/show-member-history");
var MemberView = function (_a) {
    var _b, _c;
    var orgId = _a.orgId, memberId = _a.memberId;
    var query = react_apollo_1.useQuery(ShowMember.QUERY, { variables: { organizationId: orgId, memberId: memberId } });
    var member = (_b = query.data) === null || _b === void 0 ? void 0 : _b.member;
    var date = (member === null || member === void 0 ? void 0 : member.joinedAt) ? new Date(member.joinedAt) : "";
    var joinedAtDateString = date ? frontend_toolkit_1.DateService.dateToString(date, frontend_toolkit_1.DateFormat.SHORT_DATE) : "";
    var seasonParticipants = member === null || member === void 0 ? void 0 : member.seasonParticipants;
    var historyQuery = react_apollo_1.useQuery(ShowMemberHistory.QUERY, { variables: { organizationId: orgId, memberId: memberId } });
    var memberHistoryActivities = (_c = historyQuery.data) === null || _c === void 0 ? void 0 : _c.activityLogs;
    var tabs = [
        {
            heading: "Participation",
            content: (React.createElement("div", { className: "Grid Grid--fit Grid--withGutter" },
                React.createElement("div", { className: "Grid-cell u-size4of12" },
                    React.createElement("div", { className: "u-pad" },
                        React.createElement(member_info_1.default, { member: member }))),
                React.createElement("div", { className: "Grid-cell u-size8of12" },
                    React.createElement("div", { className: "u-pad" },
                        React.createElement(member_participation_overview_1.default, { orgId: orgId, memberId: memberId, seasonParticipants: seasonParticipants })))))
        },
        {
            heading: "History",
            content: (React.createElement("div", { className: "Grid Grid--fit Grid--withGutter" },
                React.createElement("div", { className: "Grid-cell u-size8of12" },
                    React.createElement("div", { className: "u-pad" },
                        React.createElement(member_history_1.default, { orgId: orgId, memberId: memberId, memberHistoryActivities: memberHistoryActivities })))))
        },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "page-content-header Grid u-flexAlignItemsCenter" },
            React.createElement("div", { className: "Grid-cell u-xs-size1of24", style: { marginRight: "40px" } },
                React.createElement(teamsnap_ui_1.Avatar, { src: constants_1.APP_URL + "/images/avatar-placeholder.svg", size: "md" })),
            React.createElement("div", { className: "Grid-cell u-xs-size1of2" },
                React.createElement("h2", null,
                    (member === null || member === void 0 ? void 0 : member.firstName) || "",
                    " ",
                    (member === null || member === void 0 ? void 0 : member.lastName) || ""),
                joinedAtDateString ? React.createElement("h4", null,
                    "Joined ",
                    React.createElement("time", null, joinedAtDateString)) : "")),
        React.createElement(teamsnap_ui_1.Tabs, { tabs: tabs })));
};
exports.default = MemberView;
//# sourceMappingURL=member-view.js.map